export const SENSITIVE_DATA_PLACEHOLDER = "********";

export const PAYMENT_ADVICE_ENABLED = true;
export const TRANSACTIONS_ENABLED = true;
export const DEFAULT_PAGE_SIZE = 25;
